import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white/95 backdrop-blur-md border-b border-foreground-200/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 no-underline shrink-0">
          <span className="font-heading text-xl text-foreground-950 tracking-tight">pandabuy<span className="text-accent-500">.monster</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-medium text-foreground-950 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
          <Link to="/shopping-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Shopping Guide</Link>
          <a href="#categories" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Categories</a>
          <a href="#articles" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Articles</a>
          <a href="#features" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Features</a>
          <a href="#reviews" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">Reviews</a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Pandabuy Sheet
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-foreground-200/40 px-4 py-4 flex flex-col gap-3 max-h-[80vh] overflow-y-auto">
          <Link to="/" className="text-sm font-medium text-foreground-950 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-home-4-line mr-2"></i>Home
          </Link>
          <Link to="/shopping-guide" className="text-sm text-foreground-700 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-book-read-line mr-2"></i>Shopping Guide
          </Link>
          <a href="#categories" className="text-sm text-foreground-700 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-price-tag-3-line mr-2"></i>Categories
          </a>

          {/* Mobile Category Dropdown */}
          <div>
            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="w-full flex items-center justify-between text-sm text-foreground-700 py-2 cursor-pointer"
            >
              <span>
                <i className="ri-grid-line mr-2"></i>Quick Categories
              </span>
              <i className={`text-xs transition-transform ${mobileCatOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>
            {mobileCatOpen && (
              <div className="ml-4 mt-1 mb-2 flex flex-col gap-0.5 border-l-2 border-background-200 pl-3">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 py-1.5 text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    onClick={() => setMobileOpen(false)}
                  >
                    <img src={cat.image} alt={cat.name} className="w-6 h-6 rounded object-cover shrink-0" />
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </a>
                ))}
              </div>
            )}
          </div>

          <a href="#articles" className="text-sm text-foreground-700 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-article-line mr-2"></i>Articles
          </a>
          <a href="#features" className="text-sm text-foreground-700 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-star-line mr-2"></i>Features
          </a>
          <a href="#reviews" className="text-sm text-foreground-700 py-2 cursor-pointer" onClick={() => setMobileOpen(false)}>
            <i className="ri-chat-3-line mr-2"></i>Reviews
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-accent-600 transition-colors w-fit mt-2 whitespace-nowrap cursor-pointer"
            onClick={() => setMobileOpen(false)}
          >
            Pandabuy Sheet
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      )}
    </nav>
  );
}